<template>
  <div class="container">
    <span style="--d: 3"></span>
    <span style="--d: 2"></span>
    <span style="--d: 1"></span>
    <span style="--d: 0"></span>
    <span style="--d: 1"></span>
    <span style="--d: 2"></span>
    <span style="--d: 3"></span>
  </div>
</template>

<script>
export default {};
</script>

<style>
:root {
  --h: 22px;
}
.container {
  display: flex;
  align-items: center;
  position: relative;
  height: var(--h);
}
.container span {
  background: linear-gradient(to top, #d299c2 0%, #fef9d7 100%);
  width: 4px;
  height: 20%;
  border-radius: calc(var(--h) * 0.2 * 0.5);
  margin-right: 4px;
  animation: loading 2.5s infinite linear;
  animation-delay: calc(0.2s * var(--d));
}
.container span:last-child {
  margin-right: 0px;
}
@keyframes loading {
  0% {
    background-image: linear-gradient(to right, #fa709a 0%, #fee140 100%);
    height: 20%;
    border-radius: calc(var(--h) * 0.2 * 0.5);
  }
  50% {
    background-image: linear-gradient(to top, #d299c2 0%, #fef9d7 100%);
    height: 100%;
    border-radius: calc(var(--h) * 1 * 0.5);
  }
  100% {
    background-image: linear-gradient(to top, #a8edea 0%, #fed6e3 100%);
    height: 20%;
    border-radius: calc(var(--h) * 0.2 * 0.5);
  }
}
</style>